import styled from 'styled-components';
import { BodyText } from '../../../ui-toolkit';

export const GreenText = styled(BodyText)`
  color: ${(props) => props.theme.colors.primary};
`;
